import React, { useState, useEffect } from 'react'
import { Button, Input, Modal, Select } from "antd"
import { callAdditionalApi } from '../../../services/api/3dApi'
import SewingThreadWarningCompact from './SewingThreadWarningCompact'

const { Option } = Select

function AdditionalModal(props) {
    const [additionalOptions, setAdditionalOptions] = useState({})
    const {
        visible, onClose, additional = [], additionalPayLoad = {}, onUpdate,
        item, total, message, status, onChangeAdditional, loading, sewingThreadWarning
    } = { ...props }
    const additionalApi = additional.filter(i => !!i.api)

    const handleChangeInput = (field, e) => {
        onChangeAdditional(field, e.target.value)
    }

    const fetchOptions = async () => {
        try {
            await Promise.all(additionalApi.map(async item => {
                const { api, key } = { ...item }
                const { meta } = { ...api }
                const { response, values } = { ...meta }
                const { field, select } = { ...response }
                try {
                    const { data: res } = await callAdditionalApi(api)

                    const { success, message, data } = res
                    if (!success) {
                        throw new Error(message)
                    }
                    const newData = !!data && !!data[field] && data[field].map(item => {
                        return select.reduce((acc, key1) => {
                            if (item.hasOwnProperty(key1)) {
                                acc[key1] = item[key1]
                            }
                            return acc
                        }, {})
                    })

                    setAdditionalOptions({
                        ...additionalOptions,
                        [key]: newData,
                    })
                    return
                } catch (error) {
                    console.log(error.message)
                }
            }))
        } catch (error) {
            console.log(error.message)
        }
    }

    useEffect(() => {
        if (visible) {
            fetchOptions()
        }
    }, [visible])

    const handleChangeSelect = (field, value) => {
        onChangeAdditional(field, value)
    }

    const additionalRequired = additional.filter(i => i.is_required).map(i => i.key)
    const disableBtn = loading || !additionalRequired.every(i => !!additionalPayLoad[i])

    return (
        <Modal
            title="Thay đổi trạng thái lô"
            className={'CustomModal AdditionalModal'}
            visible={visible}
            width={950}
            onCancel={onClose}
            footer={[
                <div className='d-flex justify-content-between align-content-center' key='confirm'>
                    <Button key="back" size='large' onClick={onClose}>
                        Hủy
                    </Button>
                    <Button
                        key="submit"
                        type="primary"
                        size='large'
                        loading={loading}
                        onClick={onUpdate}
                        disabled={disableBtn}
                    >
                        Thay đổi
                    </Button>
                </div>
            ]}
        >

            <div className='group-additional'>
                {additional.length > 0 && additional.map((i, index) => (
                    <div key={`additional_${index}`} className={`${i.key} mb-3 px-0`}>
                        <label className='d-block font-weight-bold' style={{fontSize: '20px'}}>
                            {i.title}
                            {i.is_required &&
                                <>
                                    (<span className='text-danger'>* bắt buộc</span>)
                                </>
                            }
                        </label>
                        {i.input_type === "string" &&
                            <Input
                                value={additionalPayLoad[i.key] || ''}
                                size='large'
                                name={i.key}
                                placeholder={i.title}
                                onChange={(e) => handleChangeInput(i.key, e)}
                            />
                        }
                        {i.input_type === "select" &&
                            <Select
                                size='large'
                                value={additionalPayLoad[i.key] || ''}
                                onChange={value => handleChangeSelect(i.key, value)}
                                className='Custom'
                                dropdownClassName='dropdown-menu-650'
                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                <Option value=''>{`--- Chọn ${i.title.toLowerCase()} ---`}</Option>
                                {
                                    !!additionalOptions[i.key] && additionalOptions[i.key].length > 0 && additionalOptions[i.key].map((item, idx) => {
                                        const valueField = i.api?.meta?.values || '_id'
                                        const textField = i.api?.meta?.response?.select?.[1] || 'name'

                                        return (
                                            <Option key={`${i.key}Options_${idx}`} value={item[valueField]}>
                                                {item[textField]}
                                            </Option>
                                        )
                                    })
                                }
                            </Select>
                        }
                    </div>
                ))}
            </div>
            <p className='message-popup mt-3'>Bạn sẽ thay đổi
                <span className='font-weight-bold ml-2 Item'>{item}</span>/<span
                    className='font-weight-bold mr-2'>{total}</span>
                {item > 1 ? 'items' : 'item'} của lô sang
                <span className='font-weight-bold ml-2'>{message === "QC sau ép" ? "Chờ may" : message}({message === "QC sau ép" ? "wait_to_sew" : status})</span>?
            </p>

            {sewingThreadWarning && sewingThreadWarning.total_items > 0 &&
                <SewingThreadWarningCompact data={sewingThreadWarning}/>
            }
        </Modal>
    )
}

export default AdditionalModal